module.exports = __webpack_public_path__ + "static/media/cohorts-reader-1A.dd7bb5d8.png";